module.exports = __webpack_public_path__ + "static/img/確認一下_300×300.aa47a480.png";